export default __webpack_public_path__ + "static/gm-4179bb1bfcddf8c8cf9d21d4b9135fb1.jpeg";